"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgGithub = function SvgGithub(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M20.713 31.042a1 1 0 01.574 1.916c-2.992.897-4.673.237-6.227-1.688-.082-.1-.38-.48-.45-.565-.39-.483-.622-.677-.853-.735a1 1 0 01.486-1.94c.765.191 1.28.622 1.922 1.417.08.099.38.478.45.567 1.077 1.332 1.946 1.674 4.098 1.028zM29 31.13V35a1 1 0 01-2 0l.003-3.948a2.37 2.37 0 00-.661-1.836 1 1 0 01.607-1.69c3.77-.42 5.551-1.918 5.551-6.006a4.44 4.44 0 00-1.224-3.06 1 1 0 01-.213-1.04 4.07 4.07 0 00.14-2.392c-.07.015-.147.035-.231.06-.645.185-1.448.574-2.415 1.223a1 1 0 01-.819.134 12.38 12.38 0 00-6.476 0 1 1 0 01-.819-.134c-.967-.649-1.77-1.038-2.415-1.224a4.124 4.124 0 00-.23-.06 4.07 4.07 0 00.139 2.393 1 1 0 01-.213 1.04 4.443 4.443 0 00-1.224 3.09c0 4.05 1.769 5.536 5.563 6.008a1 1 0 01.596 1.687c-.468.484-.709 1.144-.659 1.885V35a1 1 0 01-2 0l.002-3.8a4.37 4.37 0 01.299-1.92c-3.741-.859-5.801-3.113-5.801-7.725a6.44 6.44 0 011.379-4.016 6.07 6.07 0 01.292-3.933 1 1 0 01.635-.565c.057-.017.127-.032.21-.044.939-.136 2.317.235 4.163 1.406a14.38 14.38 0 016.642 0c1.846-1.171 3.224-1.542 4.164-1.406.082.012.152.027.21.044a1 1 0 01.634.565 6.07 6.07 0 01.292 3.933A6.44 6.44 0 0134.5 21.52c0 4.642-2.07 6.918-5.79 7.743.238.6.34 1.242.29 1.867z",
    id: "github_svg__a"
  }));
};

var _default = SvgGithub;
exports["default"] = _default;